import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getBranchList } from '../../actions/commonAction';
import ResetPackageState from "./ResetPackageState";
import ChangeOrderWarehouse from "./ChangeOrderWarehouse";
import { Dialog, DialogTitle, DialogContent, Container, Tooltip, RadioGroup, FormControlLabel, Radio } from '@material-ui/core';
import { handleHelpDesk, openHelpDesk } from '../../reducers/uiSlice';
import CloseIcon from '@material-ui/icons/Close';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { useTranslation } from 'react-i18next';
import UniDialog from '../Common/UniDialog';
import { useToken } from '../../utilities/hooks';

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.paper,
        minHeight: '80vh'
    },
}));

const RESET_PACKAGE_STATE = 'resetPackageState';
const CHANGE_ORDER_WAREHOUSE = 'changeOrderWarehouse';
const BATCH_CHANGE_WAREHOUSE = 314;

function HelpDesk() {
    const classes = useStyles();
    const { t } = useTranslation('helpDesk');
    const dispatch = useDispatch();
    const tokenContents = useToken();
    const openModal = useSelector(openHelpDesk);
    const [selectedComponent, setSelectedComponent] = useState(RESET_PACKAGE_STATE);
    const [branches, setBranches] = useState([]);

    const userHasBatchChangeWarehouse = tokenContents.uiAbilities.includes(BATCH_CHANGE_WAREHOUSE);

    useEffect(() => {
        if (openModal) {
            dispatch(getBranchList()).then((branches) => {
                setBranches(branches);
            });
        }
    }, [openModal]);

    return (
        <UniDialog
            id='helpdesk_main_unidialog'
            title={t('title_help_desk')}
            fullWidth
            maxWidth='sm'
            disableDefaultButtons
            open={openModal}
            onClose={handleClose}
        >
            <Grid
                container
                alignItems="center"
                justify="center"
            >
                {userHasBatchChangeWarehouse &&
                    <Grid item xs={12} style={{ padding: 16 }}>
                        <RadioGroup
                            id='helpdesk_main_radiogroup'
                            value={selectedComponent}
                            onChange={(event) => setSelectedComponent(event.target.value)}
                            style={{ flexDirection: 'row' }}
                        >
                            <FormControlLabel id='helpdesk_resetstate_formcontrollabel' value={RESET_PACKAGE_STATE} control={<Radio />} label={t('package_state_reset')} />
                            <FormControlLabel id='helpdesk_changewarehouse_formcontrollabel' value={CHANGE_ORDER_WAREHOUSE} control={<Radio />} label={t('change_warehouse')} />
                        </RadioGroup>
                    </Grid>
                }
                <Grid item xs={12} style={{ padding: 16 }}>
                    {selectedComponent === RESET_PACKAGE_STATE &&
                        <ResetPackageState branches={branches} />
                    }
                    {selectedComponent === CHANGE_ORDER_WAREHOUSE &&
                        <ChangeOrderWarehouse branches={branches} />
                    }
                </Grid>
            </Grid>
        </UniDialog>
    );

    /**
     * close the dialog
    */
    function handleClose() {
        dispatch(handleHelpDesk(false))
    }
}

export default HelpDesk;